import { render, staticRenderFns } from "./ViewDocumentsCategory.vue?vue&type=template&id=8e763146"
import script from "./ViewDocumentsCategory.vue?vue&type=script&lang=js"
export * from "./ViewDocumentsCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports